module.exports = __webpack_public_path__ + "img/culture.50ee3364.svg";